/**
 * TIJD Module Seeds — Fase 0 TGL Split
 *
 * Created: 17 maart 2026 (Fase 0 stap 0.9)
 * Activated: 18 maart 2026 (Fase 0 activation batch)
 *
 * All 16 TIJD seeds local (batch 1-8, s23-s30).
 * Replaces the TIJD portion of TGL/index.ts.
 *
 * See docs/PROJECT_STATUS_AND_ROADMAP.md for project status.
 */

import tijdAnaloog from './TIJD-ANALOOG.json'
import tijdAnaloogGedetailleerd from './TIJD-ANALOOG-GEDETAILLEERD.json'
import tijdDigitaal from './TIJD-DIGITAAL.json'
import tijd1224 from './TIJD-12-24.json'
import tijdConversie from './TGL-TIJD-CONVERSIE.json'
import tijdDuur from './TGL-TIJD-DUUR.json'
import tijdSamengesteld from './TGL-TIJD-SAMENGESTELD.json'
import tijdOmrekenen from './TGL-TIJD-OMREKENEN.json'
import tijdPlanning from './TGL-TIJD-PLANNING.json'
import tijdSchema from './TGL-TIJD-SCHEMA.json'
import tijdKalender from './TGL-TIJD-KALENDER.json'
import tijdDiagram from './TGL-TIJD-DIAGRAM.json'
import tijdSnelheid from './TGL-TIJD-SNELHEID.json'
import tijdAfstand from './TGL-TIJD-AFSTAND.json'
import tijdGemiddelde from './TGL-TIJD-GEMIDDELDE.json'
import tijdTijdzones from './TGL-TIJD-TIJDZONES.json'

const TIJD_FAMILY_SEEDS = [
  // === Skill: klokkijken (groep 6) ===
  { file: 'src/content/seeds/TIJD/TIJD-ANALOOG.json', data: tijdAnaloog },
  {
    file: 'src/content/seeds/TIJD/TIJD-ANALOOG-GEDETAILLEERD.json',
    data: tijdAnaloogGedetailleerd,
  },
  { file: 'src/content/seeds/TIJD/TIJD-DIGITAAL.json', data: tijdDigitaal },
  { file: 'src/content/seeds/TIJD/TIJD-12-24.json', data: tijd1224 },
  {
    file: 'src/content/seeds/TIJD/TGL-TIJD-CONVERSIE.json',
    data: tijdConversie,
  },

  // === Skill: tijdrekenen (groep 7) ===
  { file: 'src/content/seeds/TIJD/TGL-TIJD-DUUR.json', data: tijdDuur },
  {
    file: 'src/content/seeds/TIJD/TGL-TIJD-SAMENGESTELD.json',
    data: tijdSamengesteld,
  },
  {
    file: 'src/content/seeds/TIJD/TGL-TIJD-OMREKENEN.json',
    data: tijdOmrekenen,
  },
  { file: 'src/content/seeds/TIJD/TGL-TIJD-PLANNING.json', data: tijdPlanning },
  { file: 'src/content/seeds/TIJD/TGL-TIJD-SCHEMA.json', data: tijdSchema },
  { file: 'src/content/seeds/TIJD/TGL-TIJD-KALENDER.json', data: tijdKalender },
  { file: 'src/content/seeds/TIJD/TGL-TIJD-DIAGRAM.json', data: tijdDiagram },

  // === Skill: snelheid (groep 8) ===
  { file: 'src/content/seeds/TIJD/TGL-TIJD-SNELHEID.json', data: tijdSnelheid },
  { file: 'src/content/seeds/TIJD/TGL-TIJD-AFSTAND.json', data: tijdAfstand },
  {
    file: 'src/content/seeds/TIJD/TGL-TIJD-GEMIDDELDE.json',
    data: tijdGemiddelde,
  },
  {
    file: 'src/content/seeds/TIJD/TGL-TIJD-TIJDZONES.json',
    data: tijdTijdzones,
  },
] as const

const allQuestions = TIJD_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Tijd',
  moduleCode: 'TIJD',
  version: '1.0-standalone',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
